<template>
  <div class="signup el-reset">
    <el-form
      ref="form"
      :model="form"
      :rules="rules"
    >
      <el-row
        v-if="isUpdating"
        :gutter="20"
      >
        <el-col :sm="12">
          <label
            class="input-file"
            @click="handlePopupPhotoEditor('profile')"
          >
            <i-avatar
              v-if="profileUrl"
              :url="profileUrl"
            />
            <div
              v-else
              class="empty circle"
              v-text="'+'"
            />
            <span>{{ $t('general.editProfileImg') }}</span>
          </label>
        </el-col>
        <el-col :sm="12">
          <label
            class="input-file"
            @click="handlePopupPhotoEditor('coverPhoto')"
          >
            <img
              v-if="coverPhotoUrl"
              class="rectangle"
              :src="coverPhotoUrl"
            >
            <div
              v-else
              class="empty rectangle"
              v-text="'+'"
            />
            <span>{{ $t('general.editCoverImg') }}</span>
          </label>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :sm="12">
          <el-form-item
            prop="email"
            :label="$t('email')"
            label-position="top"
          >
            <el-input
              v-model="form.email"
              :placeholder="$t('email')"
            />
          </el-form-item>
        </el-col>
        <el-col :sm="12">
          <span
            v-show="isEmailHintShow"
            class="email-hint"
          >{{ $t('vrlounge.cannotChangeAfterSubmit') }}</span>
          <el-form-item
            v-if="isCreating"
            prop="confirmEmail"
            :label="$t('general.confirmEmail')"
            label-position="top"
          >
            <el-input
              v-model="form.confirmEmail"
              :placeholder="$t('general.confirmEmail')"
              @focus="isEmailHintShow = true"
              @blur="isEmailHintShow = false"
            />
          </el-form-item>
          <el-form-item
            v-if="isUpdating"
            :label="$t('general.password')"
            label-position="top"
          />
          <el-link
            v-if="isUpdating"
            class="change-password"
            type="warning"
            @click="$emit('to-change-password')"
          >
            {{ $t('general.changePassword') }}
          </el-link>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :sm="12">
          <el-form-item
            v-if="isCreating"
            prop="password"
            :label="$t('general.password')"
            label-position="top"
          >
            <el-input
              v-model="form.password"
              password
              show-password
              :placeholder="$t('general.password')"
            />
          </el-form-item>
        </el-col>
        <el-col :sm="12">
          <el-form-item
            v-if="isCreating"
            prop="confirmPassword"
            :label="$t('general.confirmPassword')"
            label-position="top"
          >
            <el-input
              v-model="form.confirmPassword"
              password
              show-password
              :placeholder="$t('general.confirmPassword')"
            />
          </el-form-item>
        </el-col>
      </el-row>
      <el-row
        v-if="isUpdating"
        :gutter="20"
      >
        <el-col :sm="12">
          <el-form-item
            prop="firstName"
            :label="$t('firstName')"
            label-position="top"
          >
            <el-input
              v-model="form.firstName"
              :placeholder="$t('firstName')"
            />
          </el-form-item>
        </el-col>
        <el-col :sm="12">
          <el-form-item
            prop="lastName"
            :label="$t('lastName')"
            label-position="top"
          >
            <el-input
              v-model="form.lastName"
              :placeholder="$t('lastName')"
            />
          </el-form-item>
        </el-col>
      </el-row>
      <el-row
        v-if="isUpdating"
        :gutter="20"
      >
        <el-col :sm="12">
          <el-form-item
            prop="nickname"
            :label="$t('general.knownAs')"
            label-position="top"
          >
            <el-input
              v-model="form.nickname"
              :placeholder="$t('general.knownAs')"
            />
          </el-form-item>
        </el-col>
        <el-col :sm="12">
          <el-form-item
            prop="company"
            :label="$t('company')"
            label-position="top"
          >
            <el-input
              v-model="form.company"
              :placeholder="$t('company')"
            />
          </el-form-item>
        </el-col>
      </el-row>
      <el-row
        v-if="isUpdating"
        :gutter="20"
      >
        <el-col :sm="12">
          <el-form-item
            prop="position"
            :label="$t('general.position')"
            label-position="top"
          >
            <el-input
              v-model="form.position"
              :placeholder="$t('general.position')"
            />
          </el-form-item>
        </el-col>
        <el-col :sm="12">
          <el-form-item
            prop="phone"
            :label="$t('phone')"
            label-position="top"
          >
            <vue-tel-input
              v-model="form.phone"
              class="phone-input"
              mode="international"
            />
          </el-form-item>
        </el-col>
      </el-row>
      <el-row
        v-if="isUpdating"
        :gutter="20"
      >
        <el-col :sm="12">
          <el-form-item
            prop="country"
            :label="$t('location')"
            label-position="top"
          >
            <el-select
              v-model="form.country"
              :placeholder="$t('location')"
              :no-match-text="'no result'"
              filterable
            >
              <el-option
                v-for="(country, isoCode) in countryList"
                :key="isoCode"
                style="max-width: 100vw"
                :label="`${country.en} ${country.ch}`"
                :value="isoCode"
              />
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-form-item
        v-if="isCreating"
        prop="agree"
      >
        <el-checkbox
          v-model="form.agree"
          class="overflow-x"
          style="vertical-align: text-top"
        >
          <el-link type="warning">
            {{ $i18n.locale === 'zh-tw' ? '隱私政策' : 'Privacy Policy' }}
          </el-link>
        </el-checkbox>
      </el-form-item>
    </el-form>
    <div class="signup__action">
      <button
        class="el-button"
        @click="handleSubmit"
      >
        {{ $t('Submit') }}
      </button>
      <el-link
        v-if="isCreating"
        type="warning"
        @click="$emit('to-login')"
      >
        {{ $t('general.login') }}
      </el-link>
    </div>
    <i-modal
      ref="cover-photo-editor-modal"
      bgcolor="rgba(0,0,0,0.7)"
      :closeable="false"
    >
      <cover-photo-editor
        :width="coverConfig.width"
        :height="coverConfig.height"
        :border-radius="coverConfig.borderRadius"
        :type="coverConfig.type"
        @save="updateCoverImageUrl"
        @close="closeModal"
      />
    </i-modal>
    <i-modal
      ref="avatar-editor-modal"
      bgcolor="rgba(0,0,0,0.7)"
      :closeable="false"
    >
      <avatar-editor
        @close="closeModal"
      />
    </i-modal>
  </div>
</template>
<script>
import countries from '@/assets/doc/countries.json'
import IAvatar from '@/components/IAvatar'
import IModal from '@/components/IModal'
import { VueTelInput } from 'vue-tel-input/dist/vue-tel-input.common.js'
import { mapGetters, mapActions } from 'vuex'
import { Message } from 'element-ui'
import { MODALS } from '../index'
// import {checkUserExist} from '@/api/auth'
import { dataURLtoFile, uploadFile } from '@/api/files'
import CoverPhotoEditor from './CoverPhotoEditor.vue'
import AvatarEditor from './AvatarEditor.vue'

export default {
  name: 'VrLoungeEdit',
  components: {
    IAvatar,
    IModal,
    VueTelInput,
    CoverPhotoEditor,
    AvatarEditor
  },
  directives: {
    customPhoneInput: {
      bind (el) {
        const labels = el.querySelectorAll('label')
        const inputs = el.querySelectorAll('input')
        labels.forEach(label => label.remove())
        inputs.forEach(input => {
          input.style.paddingTop = '0px'
        })
      }
    }
  },
  props: {
    type: {
      type: String, // 'create | update | profile'
      required: true
    },
    formData: {
      type: Object,
      default: () => ({})
    }
  },
  data () {
    const validateEmail = (rule, value, callback) => {
      const regex = /^.+@.+$/
      const result = regex.test(value)
      if (result) callback()
      else callback(new Error('invalid email'))
    }
    const validatePassword = (rule, value, callback) => {
      callback(new Error(this.$t('vrlounge.passwordRule')))
    }
    const validateConfirmPassword = (rule, value, callback) => {
      if (this.form.password === this.form.confirmPassword) callback()
      else callback(new Error(this.$t('general.unmatched', { col: this.$t('general.password') })))
    }
    const validateConfirmEmal = (rule, value, callback) => {
      if (this.form.email === this.form.confirmEmail) callback()
      else callback(new Error(this.$t('general.unmatched', { col: this.$t('email') })))
    }
    const validateAgree = (rule, value, callback) => {
      if (this.form.agree === true) callback()
      else callback(new Error(this.$t('vrlounge.agreeToContinue')))
    }
    return {
      countryList: countries,
      // profileUrl: (this.formData.portrait ? this.formData.portrait.cutUrl : this.formData.profileUrl) || '',
      profileUrl: this.formData.profileUrl || '',
      coverPhotoUrl: this.formData.coverPhotoUrl || '',
      isEmailHintShow: false,
      form: {
        email: this.formData.email || '',
        firstName: this.formData.firstName || '',
        lastName: this.formData.lastName || '',
        phone: this.formData.phone || '',
        company: this.formData.company || '',
        position: this.formData.position || '',
        country: this.formData.country || '',
        nickname: this.formData.nickname || '',
        password: '',
        confirmEmail: '',
        confirmPassword: '',
        role: this.formData.role || 'VISITOR',
        agree: false
      },
      rules: {
        firstName: [{ max: 25 }, { required: true, message: this.$t('general.required') }],
        lastName: [{ max: 25 }, { required: true, message: this.$t('general.required') }],
        nickname: [{ required: true, message: this.$t('general.required') }],
        email: [{ validator: validateEmail }, { required: true, message: this.$t('general.required') }],
        confirmEmail: [{ validator: validateConfirmEmal }, { required: true, message: this.$t('general.required') }],
        password: [{ validator: validatePassword }, { required: true, message: this.$t('general.required') }],
        confirmPassword: [{ validator: validateConfirmPassword }, { required: true, message: this.$t('general.required') }],
        phone: [{ required: true, message: this.$t('general.required') }],
        position: [{ required: true, message: this.$t('general.required') }],
        country: [{ required: true, message: this.$t('general.required') }],
        company: [{ required: true, message: this.$t('general.required') }],
        agree: [{ validator: validateAgree }]
      },
      coverPhotoFile: null,
      coverConfig: {
        width: 300,
        height: 150,
        borderRadius: 0,
        type: 'coverPhoto'
      }
    }
  },
  computed: {
    ...mapGetters({
      userId: 'auth/objectId'
    }),
    isCreating () {
      return this.type === MODALS.signup
    },
    isUpdating () {
      return this.type === MODALS.update
    }
  },
  methods: {
    ...mapActions({
      signup: 'auth/signup',
      update: 'auth/update'
    }),
    handlePopupPhotoEditor (type) {
      switch (type) {
        case 'profile':
          this.$refs['avatar-editor-modal'].show()
          break

        case 'coverPhoto':
          this.$refs['cover-photo-editor-modal'].show()
          break
      }
    },
    async updateCoverImageUrl ({ img }) {
      try {
        Message(this.$t('pilotRecorderUploading'))
        const path = this.userId
        this.coverPhotoFile = dataURLtoFile(img)
        this.coverPhotoUrl = img
        const coverPhotoUrl = await uploadFile(this.coverPhotoFile, path)
        const payload = {
          coverPhotoUrl
        }
        this.coverPhotoUrl = coverPhotoUrl
        await this.update(payload)
        Message.success(this.$t('updateSuccess'))
      } catch (error) {
        this.showError(error)
      }
    },
    handleSubmit () {
      this.$refs.form.validate((result, fields) => {
        if (result !== true) {
          // booking.requiredField
          Object.keys(fields)
            .map(key => {
              const errorType = fields[key][0].message.includes('required') ? this.$t('booking.requiredField') : this.$t('IncorrectFormat')
              return `${this.$t(this.transformKeyToI18nText(key))}: ${errorType}`
            })
            .forEach(msg => {
              Message.error(msg)
            })
          return
        }
        // this.isCreating ? this.handleSignup() : this.handleUpdate()
        this.handleUpdate()
      })
    },
    async handleUpdate () {
      try {
        Message(this.$t('pilotRecorderUploading'))
        const formData = {
          firstName: this.form.firstName,
          lastName: this.form.lastName,
          email: this.form.email,
          nickname: this.form.nickname,
          country: this.form.country,
          companyDisplayName: this.form.company,
          occupationCustom: this.form.position,
          phone: this.form.phone
        }
        await this.update(formData)
        Message.success(this.$t('updateSuccess'))
        this.$emit('update')
      } catch (error) {
        this.showError(error)
      }
    },
    showError (err) {
      Message({
        message: err,
        type: 'error'
      })
      return Promise.reject(err)
    },
    transformKeyToI18nText (key) {
      switch (key) {
        case 'nickname':
          return 'general.knownAs'
        case 'position':
          return 'general.position'
        case 'country':
          return 'location'
        default:
          return key
      }
    },
    closeModal () {
      // this.profileUrl = (this.formData.portrait ? this.formData.portrait.cutUrl : this.formData.profileUrl) || ''
      this.profileUrl = this.formData.profileUrl || ''
      this.coverPhotoUrl = this.formData.coverPhotoUrl || ''
      this.$refs['cover-photo-editor-modal'].hide()
      this.$refs['avatar-editor-modal'].hide()
    }
  }
}
</script>
<style src="vue-tel-input/dist/vue-tel-input.css"></style>
<style lang="stylus" scoped>
@import '~css/addon/colors'
@import '~css/addon/main'
.signup {
  overflow-x: hidden
  overflow-y: auto
  padding: 0 20px
  .signup__action {
    margin-top: 10px
    text-align: center
  }
  @media (max-width: $response-xs) {
    padding: 0px
  }
}
.el-form {
  padding-top: 20px
}
.el-select {
  width: 100%
}
.el-button {
  width: 100%
  margin-bottom: 20px
}
.el-radio {
  color: $white
}
.el-checkbox {
  color: $white
}

.phone-input {
  clear: both
  height: 40px
  background: white
}
.email-hint {
  color: white
  position: absolute
  margin-top: -10px
  margin-left: 10px
  font-size: 14px
}

.change-password {
  margin-top: -25px
}
.input-file {
  margin-bottom: 20px
  font-size: 16px
  color: $white
  display: block
  height: 50px
  align-items: center
  display: flex
  cursor: pointer

  span {
    margin-left: 10px
  }

  .empty {
    color: $white
    border: 2px dashed $white
    text-align: center
    font-size: 20px
    cursor: pointer
  }
  .circle {
    height: 50px
    width: 50px
    line-height: 45px
    border-radius: 50% 50%
  }
  .rectangle {
    line-height: 35px
    height: 40px
    width: 80px
  }
}
.overflow-x {
  width: 100%
  overflow-x: auto
}

.separater {
  color: $white
  margin: 0 16px
}

.el-button {
  background-color: $pink-color
  width: 100%
  font-size: 20px
  color: $white
  border: none
}

</style>
